import { render, staticRenderFns } from "./EntregaDocumentos.vue?vue&type=template&id=bde5019e"
import script from "./EntregaDocumentos.vue?vue&type=script&lang=js"
export * from "./EntregaDocumentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bde5019e')) {
      api.createRecord('bde5019e', component.options)
    } else {
      api.reload('bde5019e', component.options)
    }
    module.hot.accept("./EntregaDocumentos.vue?vue&type=template&id=bde5019e", function () {
      api.rerender('bde5019e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/cotejo/staff/EntregaDocumentos.vue"
export default component.exports